import { createFeatureSelector, MemoizedSelector } from '@ngrx/store';
import { PAYMENT_FEATURE, PaymentState, StateWithPayment } from '../payment-state';

export const getPaymentState: MemoizedSelector<StateWithPayment, PaymentState> =
  createFeatureSelector<PaymentState>(PAYMENT_FEATURE);
